import { BlogPostQuery, PageInfoFragment } from '@labs/schema';
import { BlogEntry } from '@labs/ux';
import { graphql, HeadProps, PageProps } from 'gatsby';
import * as React from 'react';

export const query = graphql`
  query BlogPost($slug: String!) {
    blogPost(slug: $slug) {
      ...BlogPostQuery
    }
  }
`;

export const Head = (props: HeadProps<BlogPostQuery, PageInfoFragment>) => {
  const image = JSON.parse(
    props.data.blogPost.social_media_image.source ||
      props.data.blogPost.teaser_image.source ||
      '{}',
  );
  const description =
    props.data.blogPost.social_media_lead || props.data.blogPost.lead;
  return (
    <>
      <html lang="en" />
      <title>{`${props.data.blogPost.title} | Amazee Labs`}</title>
      <meta name="og:site_name" content="Amazee Labs" />
      <meta
        property="og:title"
        content={`${props.data.blogPost.title} | Amazee Labs`}
      />
      <meta name="description" content={description} />
      <meta name="og:description" content={description} />
      <link
        rel="canonical"
        href={`https://www.amazeelabs.com${props.pageContext.slug}/`}
      />
      <meta
        property="og:url"
        content={`https://www.amazeelabs.com${props.pageContext.slug}/`}
      />
      <meta property="og:locale" content="en_EN" />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={image?.src} />
      <meta
        property="og:article:published_time"
        content={props.data.blogPost.date}
      />
    </>
  );
};

const BlogEntryTemplate = ({
  data,
}: PageProps<BlogPostQuery, PageInfoFragment>) => {
  return <BlogEntry {...data.blogPost} />;
};

export default BlogEntryTemplate;
